/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolPlaceIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-place"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 22Q12 22 11.78 22Q11.55 22 11.11 21.85Q10.68 21.7 10.3 21.38Q8.5 19.75 7.16 18.26Q5.83 16.77 4.95 15.39Q4.08 14 3.64 12.69Q3.2 11.38 3.2 10.13Q3.2 6.4 5.78 3.79Q8.35 1.18 12 1.18Q15.65 1.18 18.23 3.79Q20.8 6.4 20.8 10.13Q20.8 11.38 20.36 12.69Q19.93 14 19.05 15.39Q18.18 16.77 16.84 18.26Q15.5 19.75 13.7 21.38Q13.32 21.7 12.89 21.85Q12.45 22 12 22ZM12 12.25Q12 12.25 12.46 12.25Q12.93 12.25 13.59 11.59Q14.25 10.93 14.25 10Q14.25 9.07 13.59 8.41Q12.93 7.75 12 7.75Q11.07 7.75 10.41 8.41Q9.75 9.07 9.75 10Q9.75 10.93 10.41 11.59Q11.07 12.25 12 12.25Z" fill={color} />
    </svg>
  );
}
